import { FC } from 'react';
import Lottie from 'react-lottie';

import { APTypography } from '@astropay/web-core-library';
import { Box } from '@material-ui/core';
import ErrorAnimation from 'assets/error-animation.json';

import { translate } from 'common/config/i18n';

const NotFoundPage: FC = () => {
  return (
    <Box textAlign="center">
      <Box>
        <APTypography textStyle="Typography_Poppins_16px_SemiBold">
          {translate('one_touch_page_not_found')}
        </APTypography>
      </Box>
      <Box>
        <APTypography textStyle="Typography_Poppins_14px_Regular">
          {translate('one_touch_page_not_found_description')}
        </APTypography>
      </Box>
      <Box
        display={'flex'}
        flexDirection={'column'}
        justifyContent={'space-between'}
        my={1}
        width="100%"
      >
        <Lottie
          height={150}
          width={150}
          style={{ marginTop: '48px' }}
          isPaused={true}
          options={{ animationData: ErrorAnimation }}
        />
      </Box>
    </Box>
  );
};

export default NotFoundPage;
